import React from "react";
import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Container
      className="d-flex flex-column justify-content-center align-items-center text-center"
      style={{ minHeight: "70vh" }}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="display-1 fw-bold not-found-code">
          404
        </h1>
        <h3 className="fw-bold mb-3 section-heading">
          Page Not Found
        </h3>
        <p className="text-muted mb-4" style={{ maxWidth: "460px" }}>
          The page you're looking for doesn't exist or has been moved.
          Let's get you back on track.
        </p>
        <Button
          variant="warning"
          size="lg"
          className="fw-bold px-4"
          onClick={() => navigate("/")}
        >
          Go Home
        </Button>
      </motion.div>
    </Container>
  );
};

export default NotFound;
